export const dividirPalabras = (texto) => {
    const arrayTexto = texto.split('-');
    const letras = arrayTexto[0].split('');
    const numeros = arrayTexto[1];
    const letrasFinal = letras.join(' ');

    return `${ letrasFinal } ${ numeros }`;
}